import { render, staticRenderFns } from "./ActivityVideoDisappearing.vue?vue&type=template&id=438c2f45&scoped=true"
import script from "./ActivityVideoDisappearing.vue?vue&type=script&lang=ts"
export * from "./ActivityVideoDisappearing.vue?vue&type=script&lang=ts"
import style0 from "./ActivityVideoDisappearing.vue?vue&type=style&index=0&id=438c2f45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438c2f45",
  null
  
)

/* custom blocks */
import block0 from "./ActivityVideoDisappearing.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports